// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".b-404{padding:80px 0;display:flex;flex-direction:column;align-items:center}@media only screen and (min-width:992px){.b-404{padding:174px 0}}.b-404__title{font-size:34px;line-height:1;font-weight:600;margin-bottom:30px}.b-404__text{font-size:18px;line-height:24px}.b-404__link{color:var(--7k9zs9)}", ""]);
// Exports
module.exports = exports;
